import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ca00ba2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置")

import { ref, reactive, onBeforeMount, computed, onMounted } from 'vue'
import tbMix from '@/global_mixin/tableMixin'
import quarterOfYear from 'dayjs/plugin/quarterOfYear'
import dayjs from 'dayjs'
import _ from 'lodash'
import { formatNumber} from '@/utils/index'
import { useRouter } from 'vue-router'
import Api from '@/http/modules/index'
import { ElMessage } from 'element-plus'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
	'POST/cost/payable': fetchList,
	// 应付账款_导出
	'POST/cost/download': exportApi,
	// 提现数据查询
	'POST/convert_to_cash/query':convertToCashQueryApi,
	// 成本数据查询
	'POST/rt/query':rtQueryApi,
	// 公司下拉款
	'GET/rt/company/list': rtCompanyListApi,
} = Api

const router = useRouter()
const companyList=ref([])
const tableLoading=ref(false)
const searchEle = ref()
const tableData = ref<{resourceId: number, isColorRow: boolean}[]>([])
const dynamicColumns = ref([])
const searchObj: any = reactive({
  page: 1, size: 30, total: 0,
	type: 'month',
	month: [dayjs().startOf('year').format('YYYY-MM-DD'),dayjs().endOf('year').format('YYYY-MM-DD')],
	// 译员id
	resourceId: '',
	// 译员公司
	resourceCompany: '',
	// 多公司/币种 默认不勾选，传null或空，勾选则传true
	existMultipleResourceId: false,
	//显示金额为零 
	amountType:"",
	// 类型 (co2,mars)
	source:'',
	// 是否更新
	update:false ,
	// 排序
	sortType:"",
})
const exportParam: any = ref({
	type: 'month',
	month: [dayjs().startOf('year').format('YYYY-MM-DD'),dayjs().endOf('year').format('YYYY-MM-DD')],
	// 译员id
	resourceId: '',
	// 译员公司
	resourceCompany: '',
	// 多公司/币种 默认不勾选，传null或空，勾选则传true
	existMultipleResourceId:null, 
	//显示金额为零 
	amountType:"",
	// 类型 (co2,mars)
	source:'',
	// 是否更新
	update:false ,
	// 排序
	sortType:""
})
const tableHeight = window.innerHeight - 215
const searchHandle = async () => {
  let params = { 
    query: {
      ...searchObj,
      paymentTime: {
        from: searchObj.type !== 'quarter' ? searchObj.month[0] : dayjs(searchObj.month[0]).startOf('quarter').format('YYYY-MM-DD'),
        to: searchObj.type !== 'quarter' ? searchObj.month[1] : dayjs(searchObj.month[1]).endOf('quarter').format('YYYY-MM-DD'),
      },
      existMultipleResourceId: searchObj.existMultipleResourceId || null,
    },
    page: searchObj.page,
    size: searchObj.size,
  }
	tableLoading.value = true
	exportParam.value = params.query
	fetchList(params).then((res: any) => {
		tableData.value = res.data
		dynamicColumns.value = res.data.length?res.data[0].periodBalance.map((el:any)=>el.title):[]
		searchObj.total = res.rowCount
	}).finally(() => tableLoading.value = false)
}
const filterLabel = (date:string) => {
	switch((tableData.value[0] as any).type){
		case 'month':
			return dayjs(date).endOf('month').format('YYYY-MM-DD');
		case 'quarter':
			const regex = /\d+(\.\d+)?/g;
			// 使用match方法提取所有匹配的数字
			const numbers:any = date.match(regex) || [];
			let day=new Date(Number(numbers[0]), Number(numbers[1])*3, 0).getDate()
			return `${numbers[0]}-${numbers[1]*3}-${day}`;
		case 'year':
			return `${date}-12-31`;
	}
}
const filterEndDate = ()=>{
	let date=""
	let title=(tableData.value[0] as any).periodBalance[0].title
	switch((tableData.value[0] as any).type){
		case 'month':
			date=title;
		break;
		case 'quarter':
			const regex = /\d+(\.\d+)?/g;
			// 使用match方法提取所有匹配的数字
			const numbers:any = title.match(regex) || [];
			let day=new Date(Number(numbers[0]), Number(numbers[1])*3, 0).getDate()
			date=`${numbers[0]}-${numbers[1]*3-2}-1`;
		break
		case 'year':
			date= `${title}-1-1`;
	}
	return dayjs(date).subtract(1, 'day').format('YYYY-MM-DD')
}
const cellDbClick = (row: any, column: any, cell: any, event: any) => {	
	const pattern = /\d+/g;
	const index = Number(column.property.match(pattern).join(',')); //提取index 执政对格式为'periodBalance[index][prop]'字符串
	if(column.label=='增加'||column.label=='提现'){

		let target:any=row.periodBalance[index]

		if((column.label=='增加'&&!target.creditIds.length)||(column.label=='提现'&&!target.debitIds.length)){ //creditIds||debitIds中没有值。则不跳转
			ElMessage.warning('暂无数据')
			return
		}

		if(column.label=='增加'){
			router.push({name:'Rt',query:{ids:JSON.stringify(target.creditIds)}})
			return
		}
		router.push({name:'ConvertToCash',query:{ids:JSON.stringify(target.debitIds)}})
		
	}


}
onMounted(() => {
	searchHandle()
	rtCompanyListApi().then((res:any)=>{
		companyList.value=res.company
	})
})


// -------------
const tableRowClassName = ({row, rowIndex}: any) => {
  if(!exportParam.value.existMultipleResourceId) return '';
  if(rowIndex === 0) {
    row.isColorRow = true
    return 'intervalRow'
  }
  // 判断译员id是否相同
  if(tableData.value[rowIndex - 1].isColorRow && row.resourceId === tableData.value[rowIndex - 1].resourceId){
    row.isColorRow = true
    return 'intervalRow'
  }
  // 上一行无颜色，且译员ID不用，加className
  if(!tableData.value[rowIndex - 1].isColorRow && row.resourceId !== tableData.value[rowIndex - 1].resourceId){
    row.isColorRow = true
    return 'intervalRow'
  }

  return '';
  
}


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_eptBtn = _resolveComponent("eptBtn")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, { class: "mb-10" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "应付账款" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              ref_key: "searchEle",
              ref: searchEle,
              model: _unref(searchObj),
              "label-position": "left",
              "label-width": "90px",
              disabled: tableLoading.value,
              inline: "",
              class: "searchBg"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "译员ID:",
                  prop: "resourceId"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(searchObj).resourceId,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(searchObj).resourceId) = $event)),
                      maxlength: "100",
                      placeholder: "请输入译员id",
                      class: "form-input",
                      clearable: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "时间类型：",
                  prop: "type"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(searchObj).type,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(searchObj).type) = $event)),
                      placeholder: "请选择类型"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "按月份",
                          value: "month"
                        }),
                        _createVNode(_component_el_option, {
                          label: "按季度",
                          value: "quarter"
                        }),
                        _createVNode(_component_el_option, {
                          label: "按年份",
                          value: "year"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "类型：",
                  prop: "source"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      clearable: "",
                      modelValue: _unref(searchObj).source,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(searchObj).source) = $event)),
                      placeholder: "请选择类型"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "co2",
                          value: "co2"
                        }),
                        _createVNode(_component_el_option, {
                          label: "mars",
                          value: "mars"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "金额类型：",
                  prop: "amountType"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      clearable: "",
                      modelValue: _unref(searchObj).amountType,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(searchObj).amountType) = $event)),
                      placeholder: "请选择"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "发生额为零不显示",
                          value: "OccurrenceAmount"
                        }),
                        _createVNode(_component_el_option, {
                          label: "余额为零不显示",
                          value: "Balance"
                        }),
                        _createVNode(_component_el_option, {
                          label: "发生额和余额为零不显示",
                          value: "OccurrenceAndBalance"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "排序：",
                  prop: "sortType"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      clearable: "",
                      modelValue: _unref(searchObj).sortType,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(searchObj).sortType) = $event)),
                      placeholder: "请选择"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "发生额提现倒序",
                          value: "OccurrenceDebitAmount"
                        }),
                        _createVNode(_component_el_option, {
                          label: "发生额成本倒序",
                          value: "OccurrenceCreditAmount"
                        }),
                        _createVNode(_component_el_option, {
                          label: "余额倒序",
                          value: "Balance"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "时间：",
                  prop: "date"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      type: "monthrange",
                      modelValue: _unref(searchObj).month,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(searchObj).month) = $event)),
                      "value-format": "YYYY-MM-DD",
                      "unlink-panels": "",
                      "start-placeholder": "开始时间",
                      "range-separator": "至",
                      "end-placeholder": "结束时间",
                      clearable: false
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "译员公司：",
                  prop: "resourceCompany"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(searchObj).resourceCompany,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(searchObj).resourceCompany) = $event)),
                      style: {"width":"310px"},
                      filterable: "",
                      placeholder: "请选择公司"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(companyList.value, (comp) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: comp,
                            value: comp,
                            key: comp
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { prop: "existMultipleResourceId" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_checkbox, {
                      modelValue: _unref(searchObj).existMultipleResourceId,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(searchObj).existMultipleResourceId) = $event)),
                      label: "译员ID多行",
                      border: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { prop: "update" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_checkbox, {
                      modelValue: _unref(searchObj).update,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(searchObj).update) = $event)),
                      label: "是否更新",
                      border: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _hoisted_1,
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (searchHandle())),
                      type: "primary"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (searchEle.value.resetFields()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "disabled"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _withDirectives(_createVNode(_component_eptBtn, {
      exportFn: _unref(exportApi),
      exportText: '导出',
      exportParam: exportParam.value,
      disabled: tableLoading.value
    }, null, 8, ["exportFn", "exportParam", "disabled"]), [
      [_directive_permission, 'Export']
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref: "tb",
      border: "",
      data: tableData.value,
      "row-class-name": tableRowClassName,
      onCellDblclick: cellDbClick,
      class: "mt-10",
      "max-height": tableHeight
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "译员",
          prop: "resourceId",
          width: "110",
          "show-overflow-tooltip": "",
          fixed: ""
        }),
        _createVNode(_component_el_table_column, {
          label: "公司",
          prop: "company",
          width: "120",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "币种",
          prop: "resourceCurrency",
          "show-overflow-tooltip": ""
        }),
        (tableData.value.length)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              label: filterEndDate(),
              prop: "openingBalance",
              width: "110",
              formatter: _unref(formatNumber),
              align: "right"
            }, null, 8, ["label", "formatter"]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dynamicColumns.value, (item, index) => {
          return (_openBlock(), _createBlock(_component_el_table_column, {
            key: item,
            label: item,
            align: "center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                "class-name": "course-pointer",
                width: tableData.value[0].type=='year'?'':100,
                label: "增加",
                prop: `periodBalance[${index}][credit]`,
                formatter: _unref(formatNumber),
                align: "right"
              }, null, 8, ["width", "prop", "formatter"]),
              _createVNode(_component_el_table_column, {
                "class-name": "course-pointer",
                width: tableData.value[0].type=='year'?'':100,
                label: "提现",
                prop: `periodBalance[${index}][debit]`,
                formatter: _unref(formatNumber),
                align: "right"
              }, null, 8, ["width", "prop", "formatter"]),
              _createVNode(_component_el_table_column, {
                "class-name": "course-pointer",
                width: tableData.value[0].type=='year'?'':100,
                label: "流水",
                prop: `periodBalance[${index}][flowAmount]`,
                formatter: _unref(formatNumber),
                align: "right"
              }, null, 8, ["width", "prop", "formatter"]),
              _createVNode(_component_el_table_column, {
                width: tableData.value[0].type=='year'?'':110,
                label: filterLabel(item),
                prop: `periodBalance[${index}][endingBalance]`,
                formatter: _unref(formatNumber),
                align: "right"
              }, null, 8, ["width", "label", "prop", "formatter"])
            ]),
            _: 2
          }, 1032, ["label"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, tableLoading.value]
    ]),
    _createVNode(_component_el_pagination, {
      background: "",
      small: "",
      total: _unref(searchObj).total,
      currentPage: _unref(searchObj).page,
      "onUpdate:currentPage": _cache[11] || (_cache[11] = ($event: any) => ((_unref(searchObj).page) = $event)),
      "page-size": _unref(searchObj).size,
      "onUpdate:page-size": _cache[12] || (_cache[12] = ($event: any) => ((_unref(searchObj).size) = $event)),
      class: "mt-10",
      disabled: tableLoading.value,
      "page-sizes": [30, 50, 100, 500, 1000],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _cache[13] || (_cache[13] = ()=>searchHandle()),
      onSizeChange: _cache[14] || (_cache[14] = ()=>searchHandle())
    }, null, 8, ["total", "currentPage", "page-size", "disabled"])
  ]))
}
}

})